import createClient from '../../apolloClient';
import MUTATION_BATCH_CREATE_ESIMS from '../../mutation/batchCreateEsims';

const handleBatchCreateEsims = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_BATCH_CREATE_ESIMS,
    variables,
  });
  const { batchCreateEsims } = result?.data || {};
  return batchCreateEsims;
};
export default handleBatchCreateEsims;
